import { Link } from "react-router-dom";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { PriceList } from "@/components/site/PriceList";
import { useContent } from "@/context/ContentContext";

const Express = ({ s }) => (
  <Reveal className="bg-[#1A1A1A] text-[#FDFBF7] p-10 md:p-14 mt-20" >
    <div data-testid="express-section" className="grid md:grid-cols-2 gap-10">
      <div>
        <p className="eyebrow !text-[#C4A47C]">Ekspress skredder</p>
        <h2 className="text-4xl font-medium mt-3">Trenger du det raskt?</h2>
        <p className="mt-4 text-sm text-[#D6C9BE] leading-relaxed">{s.normal_wait} Planlegg gjerne i god tid – i høysesong kan det være begrenset kapasitet.</p>
      </div>
      {s.express?.length ? (
        <ul className="self-center" data-testid="express-table">
          {s.express.map((e) => (
            <li key={e.label} className="flex items-end py-2.5 text-sm"><span>{e.label}</span><span className="dotted-leader" /><span className="text-[#C4A47C]">{e.value}</span></li>
          ))}
          <li className="text-xs text-[#8a857d] pt-3">Tillegget beregnes av totalprisen. Ekspress må alltid avtales på forhånd.</li>
        </ul>
      ) : (
        <p className="self-center text-[#D6C9BE] italic" data-testid="express-ask">Ekspresslevering avtales direkte med Liisa – spør gjerne når du kommer innom.</p>
      )}
    </div>
  </Reveal>
);

export default function Prices() {
  const c = useContent();
  return (
    <div data-testid="prices-page">
      <PageHeader eyebrow="Prisliste høsten 2026" title="Priser" testid="prices-header" />
      <section className="px-6 md:px-16 lg:px-24">
        {c && <PriceList services={c.services} />}
        <p className="mt-16 pt-6 border-t border-[#E5E0D8] text-sm text-[#5C5A56] max-w-3xl" data-testid="prices-nb-note"><strong className="text-[#1A1A1A]">NB!</strong> Alle priser er veiledende. Endelig pris fastsettes av skredderen etter vurdering av plagget, stoffet, arbeidets omfang og vanskelighetsgrad, og avtales med kunden før arbeidet starter.</p>
        {c && <Express s={c.settings} />}
        <div className="mt-16 flex flex-wrap gap-4">
          <Link to="/bestill" className="px-8 py-4 bg-[#1A1A1A] text-[#FDFBF7] text-sm hover:bg-[#8C6E48] transition-colors" data-testid="prices-book-btn">Bestill gratis prøvetime</Link>
          <Link to="/bestill?type=pristilbud#forespørsel" className="px-8 py-4 border border-[#C4A47C] text-sm hover:bg-[#C4A47C] hover:text-white transition-colors" data-testid="prices-quote-btn">Be om pristilbud</Link>
        </div>
      </section>
    </div>
  );
}
